import { render, staticRenderFns } from "./ChipGeneric.vue?vue&type=template&id=3c819ce3"
import script from "./ChipGeneric.vue?vue&type=script&lang=js"
export * from "./ChipGeneric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports